import {ColDef} from "ag-grid-community";

export function columnDefs(): ColDef[] {

    return [
        {
            headerName: "Category",
            field: "key",
            filter: true,
            width: 300,
            minWidth: 100,
            resizable: true,
            suppressSizeToFit: true,
        }, {
            headerName: "Source language",
            field: "value",
            filter: "agTextColumnFilter",
            resizable: true,
        }, {
            headerName: "Target language",
            field: "translate",
            editable: true,
            singleClickEdit: true,
            filter: "agTextColumnFilter",
            resizable: true,
        },
    ]
}
